import { TextField, TextFieldProps } from "@mui/material";
import { useEffect, useState } from "react";
import { useOffer } from "../../../Alqemi/context/OfferProvider";

interface OfferAutoUpdateTextFieldProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
  defaultValue: string;
  matchEmail: string;
  onContentChange?: (value: string) => void;
}

export default function OfferAutoUpdateTextField({
  defaultValue,
  matchEmail,
  onContentChange,
  ...props
}: OfferAutoUpdateTextFieldProps) {
  const [value, setValue] = useState(defaultValue);
  const { saveOffer } = useOffer();

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);

    // Notify parent of content changes if callback provided
    if (onContentChange) {
      onContentChange(newValue);
    }
  };

  const handleBlur = () => {
    if (value !== defaultValue) {
      saveOffer(value, matchEmail, 'email');
    }
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
    />
  );
}
